import BusinessDescriptionField from './BusinessDescriptionField.component';

export default BusinessDescriptionField;
